import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./index.css";

// Bundle version stamp — bump quando si fa deploy importante per verificare
// in console che il KDS abbia caricato il codice nuovo (le tablet kiosk a
// volte servono cache stantia dopo build).
const KDS_BUNDLE_VERSION = "022.kds-voice.aggregate-dishes.v3";
// eslint-disable-next-line no-console
console.log(`[KDS] bundle ${KDS_BUNDLE_VERSION} loaded at ${new Date().toISOString()}`);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 10_000,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
